export const isBidsPage = () => {
	return (
		window.location.pathname.includes('/bids') ||
		window.location.pathname.includes('/movingbids/') ||
		window.location.pathname.includes('-bids')
	);
};
